import { render, staticRenderFns } from "./AppServiceListCreateOrEdit.vue?vue&type=template&id=c483efb6&"
import script from "./AppServiceListCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./AppServiceListCreateOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports